import { computed, ComputedRef } from '@vue/composition-api';
import { arrayToEnumObject, ValueTypeOf } from '@berlin-front/common/utils';

export const INPUT_TYPE = arrayToEnumObject(['tel', 'text', 'number']);
export type InputType = ValueTypeOf<typeof INPUT_TYPE>;

export const TEXT_ALIGNED = arrayToEnumObject(['left', 'center', 'right']);
export type TextAlignedType = ValueTypeOf<typeof TEXT_ALIGNED>;

export const AUTOCOMPLETE = arrayToEnumObject(['on', 'off', 'tel', 'tel-national', 'username']);
export type AutocompleteType = string;

type TextFieldAttribute = {
  type: InputType;
  autocomplete: AutocompleteType;
  inputmode?: string;
  pattern?: string;
};

/**
 * テキストフィールドの属性
 * @param numerical - 数値フィールドかどうか。
 * @param textDisplayed - trueに設定された時、マスク対象テキストが表示されるリアクティブパラメータ。
 * @returns { type: string; autocomplete: string } iconは表示/非表示を表すSVGアイコン。typeはinputのtype属性。autocompleteはinputのautocomplete属性。
 */
export const useTextFieldAttribute = (phoneNumber: boolean, numerical: boolean): ComputedRef<TextFieldAttribute> =>
  computed(() => {
    const type: InputType = numerical ? INPUT_TYPE.NUMBER : INPUT_TYPE.TEXT;
    const autocomplete = numerical ? AUTOCOMPLETE.OFF : AUTOCOMPLETE.ON;
    const numericalProps = numerical
      ? {
          inputmode: 'numeric',
          pattern: '^[0-9]*$',
        }
      : {};
    const phoneNumberProps = phoneNumber
      ? {
          inputmode: 'tel',
          pattern: '^[\\-0-9]*$',
          autocomplete: AUTOCOMPLETE.USERNAME,
          name: 'tel',
          type: INPUT_TYPE.TEL,
        }
      : {};
    return { type, autocomplete, ...numericalProps, ...phoneNumberProps };
  });
